import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationAddressDetailsByCityResponse,
  IConfigurationAddressDetailsByCityResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationPincodeAndStateByCityAPI = () => {
  const [addressByCity, setAddressByCity] = useState<IConfigurationAddressDetailsByCityResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (city: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!city) {
          return;
        }
        await axios
          .get(`${CONFIGURATION_APIS?.ADDRESS_DETAILS_BY_CITY?.baseURL}${encodeURIComponent(city)}/` ?? "", {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationAddressDetailsByCityResponse>) => {
            if (res.data.status === true) {
              setAddressByCity(res.data.data);
            } else {
              toast.error("Failed to fetch address details by city");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching city details.");
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          // ... handle other errors
        }
      }
    },
    [dispatch, configuration],
  );

  return { addressByCity, execute };
};
